var widget_default = {
  "card": "Y9AWF",
  "link": "qA-5X",
  "container": "ZRhiY",
  "image": "yuenv",
  "right": "ONOs4",
  "cardLayout": "jLILd",
  "content": "OV-DH",
  "title": "SNjU5",
  "subtitle": "hpXdp",
  "button": "Zdytf",
  "button_disabled": "hxJIR",
  "buttonText": "pq6nL",
  "slimLayout": "EPTTa",
  "contentText": "N1rxC"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
